import React from 'react'
import MemberProfile from '../../MemberProfile/MemberProfile'

const MemberProfileMC = () => {
    return (
        <MemberProfile />
    )
}

export default MemberProfileMC